
<div class="view-page-title">
  <h4>{{'administration_Unauthorized_label' | translate }}</h4>
</div>
<div class="text-center">
  <div class="positiion-relative text-center" style="width:66%;margin:0 auto;">
    <div class="card m-5 bg-dark text-white" style="padding: 50px;">
      
      <div  class="my-2">
        <div class="text-center" style="color:darkgoldenrod">
          <span class="fas fa-user-shield fa-5x"></span>
        </div>
      </div>
      <div class=" text-center my-2">  
        <h4 class="mt-1" *ngIf="!isTenantUserIdAvailable" [innerHTML]="'admin_unauthorizedComp_label' | translate"></h4>
        <h4 class="mt-1" *ngIf="isTenantUserIdAvailable && !isRoleAvailable" [innerHTML]="'admin_unauthorizedRole_label' | translate "></h4>
      </div>
        <div class="text-center" *ngIf="!isTenantUserIdAvailable && isLoader">
          <i class="fa fa-2x fa-circle-o-notch fa-spin" aria-hidden="true"></i>
        </div>
    </div>
  </div>
</div>


